import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

type Props = {
  errorType: 'partial-errors' | 'all-errors';
};

export const HighFitErrorMessage: FC<Props> = ({ errorType }) => {
  const { t } = useTranslations(translations);

  if (errorType === 'partial-errors') {
    return (
      <Alert tone="critical">
        <Text>
          {t(
            "Some high-fit applicants aren't showing right now. We're doing our best to fix this. Try refreshing the page or check back later.",
          )}
        </Text>
      </Alert>
    );
  }

  if (errorType === 'all-errors') {
    return (
      <Alert tone="critical">
        <Text>
          {t(
            "We can't show high-fit applicants right now. We're doing our best to fix this. Try refreshing the page or check back later.",
          )}
        </Text>
      </Alert>
    );
  }
};
